<template>
  <div>
    <v-card>
      <v-card-title>Proceso RPP</v-card-title>
      <v-card-text>
        <v-data-table :headers="headers" :items="piezas" class="elevation-1">
          <template v-slot:item.peso_r="{ item }">
            <v-text-field
              v-model="camposBD.peso_r"
              :hide-details="true"
              dense
              single-line
              :autofocus="true"
              type="number"
              v-if="item.id === camposBD.id"
            ></v-text-field>
            <span v-else>{{ item.peso_r }}</span>
          </template>
          <template v-slot:item.largo_r="{ item }">
            <v-text-field
              v-model="camposBD.largo_r"
              :hide-details="true"
              dense
              single-line              
              type="number"
              v-if="item.id === camposBD.id"
            ></v-text-field>
            <span v-else>{{ item.largo_r }}</span>
          </template>
          <template v-slot:item.ancho_r="{ item }">
            <v-text-field
              v-model="camposBD.ancho_r"
              :hide-details="true"
              dense
              single-line              
              type="number"
              v-if="item.id === camposBD.id"
            ></v-text-field>
            <span v-else>{{ item.ancho_r }}</span>
          </template>
          <template v-slot:item.alto_r="{ item }">
            <v-text-field
              v-model="camposBD.alto_r"
              :hide-details="true"
              dense
              single-line              
              type="number"
              v-if="item.id === camposBD.id"
            ></v-text-field>
            <span v-else>{{ item.alto_r }}</span>
          </template>

          <template v-slot:item.acciones="{ item }">
            <div v-if="item.id === camposBD.id">
              <v-icon color="red" class="mr-3" @click="close">
                mdi-window-close
              </v-icon>
              <v-icon color="primary" @click="save"> mdi-content-save </v-icon>
            </div>
            <div v-else>
              <v-icon color="primary" class="mr-3" @click="editItem(item)">
                mdi-file-document-edit
              </v-icon>              
            </div>
          </template>
        </v-data-table>
      </v-card-text>      
    </v-card>
    <v-overlay :value="overlay">
      <waiting />
    </v-overlay>
  </div>
</template>

<script>
import Waiting from "./Waiting.vue";
import apicon from "../plugins/apicon";
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  components: {
    Waiting,
  },
  created: function () {},
  data() {
    return {
      camposBD: {
        id: 0,
        peso_r: null,
        largo_r: null,
        ancho_r: null,
        alto_r: null,
        pesototal_r: null,
        volumentotal_r: null,
      },
      camposDefault: {
        id: 0,
        peso_r: null,
        largo_r: null,
        ancho_r: null,
        alto_r: null,
        pesototal_r: null,
        volumentotal_r: null,
      },
      headers: [
        { text: "Piezas", value: "piezas", sortable: false },  
        { text: "Peso", value: "peso", sortable: false },
        { text: "Largo", value: "largo", sortable: false },
        { text: "Ancho", value: "ancho", sortable: false },
        { text: "Alto", value: "alto", sortable: false },
        { text: "Peso Tot", value: "pesototal", sortable: false },
        { text: "Volumen Tot", value: "volumentotal", sortable: false },
        { text: "Peso RPP.", value: "peso_r", sortable: false },
        { text: "Largo RPP.", value: "largo_r", sortable: false },
        { text: "Ancho RPP.", value: "ancho_r", sortable: false },
        { text: "Alto RPP.", value: "alto_r", sortable: false },
        { text: "Peso Tot RPP", value: "pesototal_r", sortable: false },
        { text: "Volumen Tot RPP", value: "volumentotal_r", sortable: false },
        {
          text: "Acciones",
          value: "acciones",
          sortable: false,
          width: "100px",
        },
      ],
      piezas: [],
      //editedIndex: -1,
      overlay: false,
    };
  },
  methods: {
    fillDatos: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "piezas/" + this.id)
        .then((result) => {
          if (result) {
            this.piezas = result;
          }
        });
    },
    editItem: function (item) {      
      this.camposBD = Object.assign({}, item);      
    },
    close: function () {      
        this.camposBD = Object.assign({}, this.camposDefault);        
    },
    save:async function () {
        await this.calcularPesoTotalPaquete();
        await this.calcularVolumenTotalPaquete();
      apicon.updateDataApi(apicon.getApiBaseUrl() + '/pieza/' + this.camposBD.id, this.camposBD).then(()=>{
            this.fillDatos()
          });
      this.close()
    },
    calcularPesoTotalPaquete:async function () {
      this.camposBD.pesototal_r =
        Math.round(this.camposBD.piezas * this.camposBD.peso_r * 100) / 100;
    },
    calcularVolumenTotalPaquete:async function () {
      var dim = this.camposBD.largo_r * this.camposBD.ancho_r * this.camposBD.alto_r;
      this.camposBD.volumentotal_r =
        Math.round((dim / 5000) * this.camposBD.piezas * 100) / 100;
    },
  },
  mounted: function () {
    apicon.setAuthHeaders();
    this.fillDatos();
  },
};
</script>